import styled from "styled-components";
const BranchDiv = styled.div`
margin: 1rem 1.5rem 0 2rem;
display: flex;
justify-content: left;
align-items: center;
@media only screen and (max-width: 450px){
  margin-top: 0;
  margin-right: 2rem;
  display : flex;
  flex-wrap : wrap;
  align-items: center;
  justify-content: center;
}
`;
export default BranchDiv;